export default {
  init() {
    // JavaScript to be fired on all pages
    $('.main').on('click', '.calevir_loadmore', function (e) {
      e.preventDefault();
      var calevir_loadmore_params = { 'ajaxurl': '/wp-admin/admin-ajax.php', 'posts': '', 'current_page': '1', 'max_page': null };
      var button = $(this),
        data = {
          'action': 'loadmore',
          'page': $(this).data('num'),
        };
      $.ajax({
        url: calevir_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#blog-result').append(data.actiondata);
            }
            button.text('View More');
            calevir_loadmore_params.current_page++;
            if (calevir_loadmore_params.current_page == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js